// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JRKa","col":"styles_col__347-B"};